import { apiGet } from './client';

// Workbench MVP Session B — Governance dashboard.
// Eight policy-dimension gates. Filter labels the panel and — when set to
// 'stress' or 'golden' — restricts the evidence pool used by every gate.

export type GovernanceFilter = 'all' | 'stress' | 'golden';
export type GovernanceVerdict = 'pass' | 'warn' | 'fail' | 'idle';

export interface GovernanceGate {
  gateId: string;
  displayName: string;
  category: string;
  verdict: GovernanceVerdict;
  observedValue: number | null;
  warnThreshold: number | null;
  failThreshold: number | null;
  unit: string;
  numeratorCount: number;
  denominatorCount: number;
  evidence: string;
}

export interface GovernanceSummary {
  windowDays: number;
  windowStart: string;
  windowEnd: string;
  filter: GovernanceFilter;
  evidenceTraceCount: number;
  evidenceChatCount: number;
  evidenceBenchmarkCount: number;
  evidenceMatrixCount: number;
  overallVerdict: GovernanceVerdict;
  gates: GovernanceGate[];
  generatedAt: string;
}

export const getGovernanceSummary = (windowDays = 7, filter: GovernanceFilter = 'all') =>
  apiGet<GovernanceSummary>(
    `/api/governance/summary?windowDays=${windowDays}&filter=${filter}`,
  );
